module.exports = __webpack_public_path__ + "img/back_icon.4eaa05fe.svg";